import React, { Suspense } from 'react'
import SuspenseContentFallback from './SuspenseContentFallback'

interface Props {
  children?: React.ReactNode
  fallbackDataQa?: string
}

const SuspenseContent: React.FC<Props> = ({ children, fallbackDataQa }) => {
  return <Suspense fallback={<SuspenseContentFallback dataQa={fallbackDataQa} />}>{children}</Suspense>
}

export default SuspenseContent
